export default __webpack_public_path__ + "static/media/placeholder.17d3f21e.png";